import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper/core";
import { register } from "@shopify/theme-sections";

register("collection_module", {
  onLoad() {
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const collectionModuleBreakpoint = window.matchMedia("(min-width:768px)");

    let collectionModuleCarousel;

    const breakpointCollectionModule = function () {
      if (collectionModuleBreakpoint.matches === true) {
        if (collectionModuleCarousel !== undefined)
          collectionModuleCarousel.destroy(true, true);
        return;
      } else if (collectionModuleBreakpoint.matches === false) {
        return enableSwiperCollectionModule();
      }
    };

    const enableSwiperCollectionModule = function () {
      var CollectionModuleDesc = new Swiper(
        ".swiper-container-collection-module-desc",
        {
          spaceBetween: 1,
          slidesPerView: 1,
          freeMode: false,
          watchSlidesVisibility: false,
          watchSlidesProgress: true,
          // allowTouchMove: false,
          pagination: {
            el: ".swiper-pagination-collection-module",
            clickable: true,
          },
        }
      );

      collectionModuleCarousel = new Swiper(
        ".swiper-container-collection-module",
        {
          loop: false,
          resistance: true,
          resistanceRatio: 0,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },

          navigation: {
            nextEl: ".swiper-button-next-collection",
            prevEl: ".swiper-button-prev-collection",
          },
          // thumbs: {
          //   swiper: CollectionModuleDesc,
          // },
        }
      );

      CollectionModuleDesc.on("slideChange", function () {
        collectionModuleCarousel.slideTo(this.activeIndex);
      });

      collectionModuleCarousel.on("slideChange", function () {
        CollectionModuleDesc.slideTo(this.activeIndex);
      });
    };
    // collectionModuleBreakpoint.addListener(breakpointCollectionModule);
    collectionModuleBreakpoint.addEventListener(
      "change",
      breakpointCollectionModule
    );
    breakpointCollectionModule();
  },
});
